import { COLOR } from 'app-v2/design-tokens'
import { Checkbox } from 'app/assets/icons'
import { media } from 'app/assets/styles'
import { CheckOrRadio, Error, Input } from 'app/common/forms'
import { H4, SmallText, Text } from 'app/common/typography'
import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { colors as oldColors } from 'shared/assets/styles'
import styled from 'styled-components'

const { red } = oldColors

type Props = {
    pickUpParking: boolean,
    authenticated?: Boolean,
    formik: any
}

export const CartUserPersonalInfos = ({
    pickUpParking,
    authenticated,
    formik
}: Props) => {
    const {
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur
    } = formik
    const commonInputProps = {
        handleChange,
        handleBlur,
        TextStyle: Text,
        labelColor: COLOR.PRIMARY
    }
    return (
        <div>
            <FormattedMessage id="kingdom.profile.form.information.title">
                {(text: string) => <H4>{text}</H4>}
            </FormattedMessage>
            <StyledInput
                name="firstname"
                type="text"
                labelKey="clickandcollect.userinfos.firstname.optional"
                placeholderKey="form.firstname.placeholder"
                autoComplete="given-name"
                className={errors.firstname && touched.firstname ? 'error' : ''}
                error={errors.firstname && touched.firstname}
                value={values.firstname}
                {...commonInputProps}
            />
            {errors.firstname && touched.firstname && (
                <Error errorKey={errors.firstname} />
            )}
            <StyledInput
                name="phone"
                type="text"
                labelKey="clickandcollect.userinfos.phone"
                placeholderKey="form.phone.placeholder"
                autoComplete="tel-national"
                className={errors.phone && touched.phone ? 'error' : ''}
                error={errors.phone && touched.phone}
                keyboardType="phone-pad"
                value={values.phone}
                {...commonInputProps}
            />
            {errors.phone && touched.phone && <Error errorKey={errors.phone} />}
            {pickUpParking && (
                <Fragment>
                    <StyledInput
                        name="licensePlateNumber"
                        type="text"
                        labelKey="clickandcollect.userinfos.licenseplate.number.mandatory"
                        placeholderKey="form.licenseplate.placeholder"
                        className={
                            errors.licensePlateNumber &&
                            touched.licensePlateNumber
                                ? 'error'
                                : ''
                        }
                        error={
                            errors.licensePlateNumber &&
                            touched.licensePlateNumber
                        }
                        value={values.licensePlateNumber}
                        {...commonInputProps}
                    />
                    {errors.licensePlateNumber &&
                        touched.licensePlateNumber && (
                            <Error errorKey={errors.licensePlateNumber} />
                        )}
                    <StyledInput
                        name="carColor"
                        type="text"
                        labelKey="clickandcollect.userinfos.carcolor.mandatory"
                        placeholderKey="form.carcolor.placeholder"
                        className={
                            errors.carColor && touched.carColor ? 'error' : ''
                        }
                        error={errors.carColor && touched.carColor}
                        value={values.carColor}
                        {...commonInputProps}
                    />
                    {errors.carColor && touched.carColor && (
                        <Error errorKey={errors.carColor} />
                    )}
                    {authenticated && (
                        <LicensePlateEnrolment
                            onClick={() =>
                                setFieldValue(
                                    'licensePlateEnrolment',
                                    !values.licensePlateEnrolment
                                )
                            }>
                            <CheckOrRadio
                                name="licensePlateEnrolment"
                                type="checkbox"
                                labelKey="clickandcollect.userinfos.licenseplate.enroll"
                                checked={values.licensePlateEnrolment}
                                className="agreements">
                                <Checkbox
                                    color={
                                        errors.licensePlateEnrolment &&
                                        touched.licensePlateEnrolment &&
                                        red
                                    }
                                    checked={values.licensePlateEnrolment}
                                />
                            </CheckOrRadio>
                            {errors.licensePlateEnrolment &&
                                touched.licensePlateEnrolment && (
                                    <Error
                                        errorKey={errors.licensePlateEnrolment}
                                    />
                                )}
                        </LicensePlateEnrolment>
                    )}
                </Fragment>
            )}
            <StyledInput
                name="email"
                type="mail"
                labelKey="kingdom.profile.form.identifiers.email.title"
                placeholderKey="form.email.placeholder"
                autoComplete="email"
                className={errors.email && touched.email ? 'error' : ''}
                error={errors.email && touched.email}
                keyboardType="email-address"
                value={values.email}
                disabled={!!authenticated}
                {...commonInputProps}
            />
            {errors.email && touched.email && <Error errorKey={errors.email} />}
            {authenticated && (
                <EmailInfo>
                    <SmallText>
                        <FormattedMessage id="clickandcollect.userinfos.email.info" />
                    </SmallText>
                </EmailInfo>
            )}
        </div>
    )
}

const StyledInput = styled(Input)`
    color: ${COLOR.PRIMARY};
    margin-top: 10px;
    ${media.medium`
        margin-top: 20px;
    `}
`

const EmailInfo = styled.div`
    margin-top: 10px;
    ${media.medium`
        margin-top: 20px;
    `}
`

const LicensePlateEnrolment = styled.div`
    margin-top: 20px;
`
